module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_Badges_116x116_5-dacd6a626b58d67978084fce11352f99.png";